import { useReducer, useState } from 'react';
import {startStep, finishStep} from "./CustomSteps"
import { FinishType, reducer, initialState } from './Base';
import { AuthenticatorBuilder } from 'prove-mobile-auth';
import LoginForm from './LoginForm';
import { useLoginFormHandlers } from './useLoginFormHandlers';
import { getBackendUrl, getFlowPath } from './backendUtils'

var backendUrl = ""
var flowPath = ""

const authenticator = new AuthenticatorBuilder()
    .withPixelImplementation()
    .withDeviceIpDetection()
    .withStartStep({
      execute : async (input: any)=>{
        return { authUrl : await startStep(input, flowPath, backendUrl)}
      }
    })
    .withFinishStep({
      execute : async (input: any)=>{
        return await finishStep(input, backendUrl);
      }
    })
    .build();

const LoginPixel = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [phoneNumber, setPhoneNumber] = useState('');

  const params = new URLSearchParams(window.location.search)
  const env = params.get('env')
  backendUrl = getBackendUrl(env)
  flowPath = getFlowPath(env)

  const handleLogin = async () => {
    console.log('Single Pixel Flow','');

    //set the config to the user name
    globalThis.config = state.username;
    globalThis.bearerToken = state.password.trim() || undefined;
    globalThis.phoneNumber = phoneNumber.trim() || undefined;

    //start the authentication
    await authenticator.authenticate().catch(
      function error(e: any) {
        console.log('Mobile Auth Failure', e);
      }
    );

    // "pixel" implementation does not return result to the client.
    // we need to fetch it from the server, and server must expose it somehow  
    // our demo server stores the result in a database under requestId key.        
    const finishFullRsp = await fetch(backendUrl+'/result_with_pixel?requestId='+ globalThis.startRequestId);
    var result = '';
    if (finishFullRsp.status !== 200) {
        throw new Error('Cannot get results for pixel auth ('+finishFullRsp.status+')');
    } else {
      result = await finishFullRsp.json();
      console.log('Result: ', result);
    }

    //process the response
    let finish = result as unknown as FinishType;
    console.log('Finish', finish);
    if(finish !== undefined){
      const mobileNumber = finish.phoneInfo.mobileNumber;
      const authenticated = finish.phoneInfo.authenticated;
      let payloadString = '';

      if (mobileNumber) { // US successful login
        console.log('Mobile Auth Success, returned phone number: ' + mobileNumber);
        payloadString = 'Successful Login with Mobile Number ' + mobileNumber;
      } else if (authenticated !== undefined) { // International successful login
        console.log('Authentication Result: ' + authenticated);
        payloadString = authenticated ? 'Successful Authentication' : 'Flow completed with authentication false';
      } else {
        console.log('Authentication Failed, missing phone number or authenticated result');
        payloadString = 'Missing phone number or authenticated result';
      }

      state.isError = false;

      dispatch({
        type: 'loginSuccess',
        payload: payloadString
        });
    }
    else{
      console.log('Mobile Auth Failed ');
      state.isError = true;
      dispatch({
            type: 'loginFailed',
            payload: 'Failed Login with Mobile Auth'
      });
    }

  };

  const { handleKeyPress, handleUsernameChange, handlePasswordChange } =
    useLoginFormHandlers(dispatch, state, handleLogin);

  return (
    <LoginForm
      state={state}
      onUsernameChange={handleUsernameChange}
      onPasswordChange={handlePasswordChange}
      onKeyPress={handleKeyPress}
      onLogin={handleLogin}
      title="Bank Login App - Pixel"
      buttonText="Login with Pixel"
      enablePhoneNumber={true}
      phoneNumber={phoneNumber}
      onPhoneNumberChange={(event) => setPhoneNumber(event.target.value)}
    />
  );
}
console.log(module);
export default LoginPixel;